module.exports = __webpack_public_path__ + "img/m-yishenpi.2061a174.svg";